import { useMutation } from '@apollo/client';
import type { Programming_CreateAttemptOverrideInput as CreateAttemptOverrideInput } from '__generated__/graphql-types';

import CreateAttemptOverrideMutation from 'bundles/programming/api/CreateAttemptOverride.graphql';
import type {
  CreateAttemptOverrideMutation as CreateAttemptOverrideMutationResponse,
  CreateAttemptOverrideMutationVariables,
} from 'bundles/programming/api/__generated__/CreateAttemptOverride';

export type PropsToGraphql = CreateAttemptOverrideInput;

export type PropsFromGraphql = {
  programmingCreateAttemptOverride: (
    input: CreateAttemptOverrideInput
  ) => Promise<CreateAttemptOverrideMutationResponse | undefined> | undefined;
};

export type WithProgrammingCreateAttemptOverrideProps = PropsFromGraphql;

export const useProgrammingCreateAttemptOverride = () => {
  const [mutation] = useMutation<CreateAttemptOverrideMutationResponse, CreateAttemptOverrideMutationVariables>(
    CreateAttemptOverrideMutation
  );

  return {
    programmingCreateAttemptOverride: (input: CreateAttemptOverrideInput) => {
      const {
        userId,
        courseId,
        itemId,
        maxSubmissions,
        timeLimitSeconds,
        // If not present, default to false. Always provide something (a default
        // of false) to the backend.
        startAttemptNow = false,
      } = input;
      return mutation({
        variables: {
          input: {
            userId,
            courseId,
            itemId,
            startAttemptNow,

            // Avoid including these keys at all if not defined
            ...(timeLimitSeconds !== undefined ? { timeLimitSeconds } : {}),
            ...(maxSubmissions !== undefined ? { maxSubmissions } : {}),
          },
        },
        context: { clientName: 'gatewayGql' },
      }).then((response) => response?.data ?? undefined);
    },
  };
};
